import React from 'react';
import { CommentOutlined, Domain, GridOn, GridOnOutlined, History } from '@material-ui/icons';
import AtlasIcon from '@material-ui/icons/Airplay';
import SettingsIcon from '@material-ui/icons/BrightnessLow';
import HyperGateIcon from '@material-ui/icons/Cast';
import SnippetIcon from '@material-ui/icons/Code';
import CardIcon from '@material-ui/icons/CreditCard';
import RegistryIcon from '@material-ui/icons/HdrWeak';
import InvitationsIcon from '@material-ui/icons/InsertLink';
import LockIcon from '@material-ui/icons/LockOpen';
import RolesIcon from '@material-ui/icons/Security';
import AnalyticsIcon from '@material-ui/icons/ShowChart';
import GatewayIcon from '@material-ui/icons/WifiTethering';
import TabletIcon from '@material-ui/icons/Tablet';
import AccessProfilesIconCustom from '../components/CustomIcons/AccessProfilesIconCustom.jsx';
import AdminEventsIconCustom from '../components/CustomIcons/AdminEventsIconCustom.jsx';
import AgendaIconCustom from '../components/CustomIcons/AgendaIconCustom.jsx';
import AlarmIconCustom from '../components/CustomIcons/AlarmIconCustom.jsx';
import AreasManagementIconCustom from '../components/CustomIcons/AreasManagementIconCustom.jsx';
import BookeyAvailabilityIconCustom from '../components/CustomIcons/BookeyAvailabilityIconCustom.jsx';
import CameraIconCustom from '../components/CustomIcons/CameraIconCustom.jsx';
import ChartBoxIconCustom from '../components/CustomIcons/ChartBoxIconCustom.jsx';
import CommunicationIconCustom from '../components/CustomIcons/CommunicationIconCustom.jsx';
import CopyIconCustom from '../components/CustomIcons/CopyIconCustom.jsx';
import DashboardIconCustom from '../components/CustomIcons/DashboardIconCustom.jsx';
import DoorClosedIconCustom from '../components/CustomIcons/DoorClosedIconCustom.jsx';
import EnergyManagementIconCustom from '../components/CustomIcons/EnergyManagementIconCustom.jsx';
import EventIconCustom from '../components/CustomIcons/EventIconCustom.jsx';
import InstallerOutlinedIconCustom from '../components/CustomIcons/InstallerOutlinedIconCustom.jsx';
import IntercomExtensionIconCustom from '../components/CustomIcons/IntercomExtensionIconCustom.jsx';
import IntercomManagementIconCustom from '../components/CustomIcons/IntercomManagementIconCustom.jsx';
import KeyOutlinedIconCustom from '../components/CustomIcons/KeyOutlinedIconCustom.jsx';
import ListBoxIconCustom from '../components/CustomIcons/ListBoxIconCustom.jsx';
import MapIconCustom from '../components/CustomIcons/MapIconCustom.jsx';
import MessageAlertIconCustom from '../components/CustomIcons/MessageAlertIconCustom.jsx';
import PackageCheckIconCustom from '../components/CustomIcons/PackageCheckIconCustom.jsx';
import PinIconCustom from '../components/CustomIcons/PinIconCustom.jsx';
import PickupPointIconCustom from '../components/CustomIcons/PickupPointIconCustom.jsx';
import PlatformUserIconCustom from '../components/CustomIcons/PlatformUserIconCustom.jsx';
import PrivateUnitsIconCustom from '../components/CustomIcons/PrivateUnitsIconCustom.jsx';
import SmartLocksEventsIconCustom from '../components/CustomIcons/SmartLocksEventsIconCustom.jsx';
import SmartPhoneKeyIconCustom from '../components/CustomIcons/SmartPhoneKeyIconCustom.jsx';
import StoreOutlinedIconCustom from '../components/CustomIcons/StoreOutlinedIconCustom.jsx';
import SubcompanyEventIconCustom from '../components/CustomIcons/SubcompanyEventIconCustom.jsx';
import TableKeyIconCustom from '../components/CustomIcons/TableKeyIconCustom.jsx';
import TagIconCustom from '../components/CustomIcons/TagIconCustom.jsx';
import UsersIconCustom from '../components/CustomIcons/UsersIconCustom.jsx';
import VisitorsIconCustom from '../components/CustomIcons/VisitorsIconCustom.jsx';
import WearableIconCustom from '../components/CustomIcons/WearableIconCustom.jsx';

const PATH_TO_ICON_KEY = {
  '/dashboard': 'dashboard',
  '/guests': 'guests',
  '/locks': 'locks',
  '/cameras': 'cameras',
  '/gateways': 'hyperGatesPro',
  '/atlas': 'hyperGatesAtlas',
  '/hypertouchDevices': 'hypertouchDevices',
  '/tagsManagement': 'tagsManagement',
  '/floorPlans': 'floorPlans',
  '/areasManagement': 'areasManagement',
  '/privateUnits': 'privateUnits',
  '/deliveriesManagement': 'deliveries',
  '/pickupPointsManagement': 'pickupPointsManagement',
  '/wearablesManagement': 'trackingDevices',
  '/wearableAlarmsManagement': 'wearableAlarms',
  '/intercomExtensions': 'intercomExtensionManagement',
  '/intercomManagement': 'intercomManagement',
  '/visitorsManagement': 'visitorsManagement',
  '/registry': 'itemRegistry',
  '/communications': 'communications',
  '/tickets': 'ticketsList',
  '/ticketAnalytics': 'ticketAnalytics',
  '/credentials': 'smartphones',
  '/cards': 'cards',
  '/pins': 'pins',
  '/hyperKeys': 'mechatronicsKey',
  '/invitations': 'invitationsTitle',
  '/resources': 'manageResources',
  '/availability': 'bookeyAvailability',
  '/reservations': 'reservations',
  '/manageEvents': 'manageEvents',
  '/energyManagement/dashboard': 'energyDashboard',
  '/energyManagement/units': 'energyManagementUnits',
  '/energyManagement/history': 'energyManagementHistory',
  '/analytics': 'analytics',
  '/mksRelations': 'mksRelations',
  '/mksCylinders': 'mksCylinders',
  '/mksKeys': 'mksKeys',
  '/requests': 'mksRequests',
  '/adminEvents': 'adminEvents',
  '/smartLockEvents': 'doorEvents',
  '/subcompaniesSmartLockEvents': 'doorEventsSubcompany',
  '/accessProfiles': 'accessProfiles',
  '/platformUsers': 'platformUsers',
  '/installers': 'installers',
  '/roles': 'rolesAndPermissions',
  '/customTables': 'customTables',
  '/customSnippets': 'customSnippets',
  '/luckeyStore': 'luckeyStore',
  '/settings': 'settings',
};

function normalizeSidebarIconKey(iconKey) {
  if (!iconKey) {
    return null;
  }
  if (iconKey === 'customTable' || iconKey.indexOf('/customTableDisplayView/') === 0) {
    return 'customTable';
  }
  if (PATH_TO_ICON_KEY[iconKey]) {
    return PATH_TO_ICON_KEY[iconKey];
  }
  return iconKey;
}

function getSidebarIconRenderers(classes) {
  const icon = classes && classes.icon ? classes.icon : '';
  const iconSmall = classes && classes.iconSmall ? classes.iconSmall : icon;
  const iconBig = classes && classes.iconBig ? classes.iconBig : icon;

  return {
    dashboard: () => <DashboardIconCustom className={icon} />,
    guests: () => <UsersIconCustom className={icon} style={{ width: 24.5 }} />,
    locks: () => <LockIcon className={icon} />,
    customTable: () => <GridOn className={icon} />,
    customTables: () => <GridOn className={icon} />,
    cameras: () => <CameraIconCustom className={icon} />,
    hyperGatesPro: () => <HyperGateIcon className={icon} />,
    hyperGatesAtlas: () => <AtlasIcon className={icon} />,
    gateways: () => <GatewayIcon className={icon} />,
    hypertouchDevices: () => <TabletIcon className={icon} />,
    tagsManagement: () => <TagIconCustom className={icon} style={{ width: 27 }} />,
    floorPlans: () => <MapIconCustom className={icon} />,
    areasManagement: () => <AreasManagementIconCustom className={icon} style={{ width: 22 }} />,
    privateUnits: () => <PrivateUnitsIconCustom className={icon} style={{ width: 22 }} />,
    deliveries: () => <PackageCheckIconCustom className={icon} />,
    pickupPointsManagement: () => <PickupPointIconCustom className={icon} style={{ marginTop: 2, width: 20 }} />,
    trackingDevices: () => <WearableIconCustom className={icon} />,
    wearableAlarms: () => <AlarmIconCustom className={icon} style={{ marginTop: 2, width: 20 }} />,
    intercomExtensionManagement: () => <IntercomExtensionIconCustom className={icon} />,
    intercomManagement: () => <IntercomManagementIconCustom className={icon} style={{ marginTop: 2, width: 20 }} />,
    visitorsManagement: () => <VisitorsIconCustom className={icon} />,
    itemRegistry: () => <RegistryIcon className={icon} />,
    communications: () => <CommunicationIconCustom className={icon} />,
    ticketsList: () => <ListBoxIconCustom className={icon} style={{ marginTop: 2 }} />,
    ticketAnalytics: () => <AnalyticsIcon className={icon} />,
    smartphones: () => <SmartPhoneKeyIconCustom className={icon} />,
    cards: () => <CardIcon className={icon} />,
    pins: () => <PinIconCustom className={icon} />,
    mechatronicsKey: () => <KeyOutlinedIconCustom className={icon} />,
    invitationsTitle: () => <InvitationsIcon className={icon} />,
    manageResources: () => <CopyIconCustom className={iconSmall} style={{ width: 21 }} />,
    bookeyAvailability: () => <BookeyAvailabilityIconCustom className={icon} />,
    reservations: () => <AgendaIconCustom className={icon} />,
    manageEvents: () => <EventIconCustom className={icon} />,
    analytics: () => <AnalyticsIcon className={icon} />,
    energyDashboard: () => <ChartBoxIconCustom className={icon} style={{ width: 22 }} />,
    energyManagementUnits: () => <EnergyManagementIconCustom className={icon} style={{ width: 22 }} />,
    energyManagementHistory: () => <History className={icon} style={{ width: 22 }} />,
    mksRelations: () => <GridOnOutlined className={icon} />,
    mksCylinders: () => <DoorClosedIconCustom className={iconSmall} style={{ width: 24 }} />,
    mksKeys: () => <TableKeyIconCustom className={icon} style={{ width: 24 }} />,
    mksRequests: () => <CommentOutlined className={icon} />,
    adminEvents: () => <AdminEventsIconCustom className={icon} />,
    doorEvents: () => <SmartLocksEventsIconCustom className={icon} />,
    doorEventsSubcompany: () => (
      <div style={{ position: 'relative' }}>
        <Domain className={icon} style={{ position: 'absolute', bottom: 2, fontSize: 15, right: -7 }} />
        <SubcompanyEventIconCustom className={icon} />
      </div>
    ),
    accessProfiles: () => <AccessProfilesIconCustom className={icon} />,
    platformUsers: () => <PlatformUserIconCustom className={icon} />,
    installers: () => <InstallerOutlinedIconCustom className={icon} style={{ width: 24 }} />,
    rolesAndPermissions: () => <RolesIcon className={icon} />,
    customSnippets: () => <SnippetIcon className={icon} />,
    luckeyStore: () => <StoreOutlinedIconCustom className={iconBig} />,
    settings: () => <SettingsIcon className={icon} />,
  };
}

export function getSidebarMenuRegistryEntry(menuId) {
  return null;
}

export function renderSidebarMenuIcon(iconKey, classes) {
  const normalizedKey = normalizeSidebarIconKey(iconKey);
  if (!normalizedKey) {
    return null;
  }
  const renderers = getSidebarIconRenderers(classes || {});
  const render = renderers[normalizedKey];
  if (render) {
    return render();
  }
  return null;
}
